import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import PatientBooking from "./PatientBooking";

const START = 510;
const END = 1170;
const PX = 1.25;

const T_OPT = {
  examen: ["Examen de vue", "#E3F0FF", "#2F80ED", "#12406E"],
  lentilles: ["Adaptation lentilles", "#EFE7FE", "#7C4DFF", "#3B2477"],
  livraison: ["Livraison équipement", "#E3F7EA", "#22A45D", "#14532D"],
  ajustage: ["Ajustage · SAV", "#EFF1F5", "#94A3B8", "#334155"],
  enfant: ["Bilan visuel enfant", "#FFF1E0", "#F59E0B", "#7A4A06"],
  conseil: ["Conseil · choix de monture", "#FDF2F8", "#DB2777", "#831843"],
  montage: ["Montage · réparation", "#E6F7F6", "#12A4A0", "#0B4D4B"],
  urgence: ["Urgence", "#FEE7E7", "#E5484D", "#7F1D1D"],
};

const T_AUD = {
  bilan: ["Bilan auditif", "#E3F0FF", "#2F80ED", "#12406E"],
  essai: ["Essai d'appareillage", "#EFE7FE", "#7C4DFF", "#3B2477"],
  livraison: ["Livraison appareils", "#E3F7EA", "#22A45D", "#14532D"],
  reglage: ["Réglage · suivi", "#EFF1F5", "#94A3B8", "#334155"],
  controle: ["Contrôle annuel", "#FFF1E0", "#F59E0B", "#7A4A06"],
  urgence: ["Panne · urgence", "#FEE7E7", "#E5484D", "#7F1D1D"],
};

const C_OPT = [
  ["Claire FONTAINE", "Opticienne-lunetière", "CF", "#2F80ED"],
  ["Marc DEVEAUX", "Opticien-lunetier", "MD", "#7C4DFF"],
  ["Léa BONNET", "Monteuse-vendeuse", "LB", "#12A4A0"],
];
const C_AUD = [
  ["Samir HADDAD", "Audioprothésiste", "SH", "#2F80ED"],
  ["Julie REY", "Audioprothésiste", "JR", "#7C4DFF"],
];

const R_OPT = [
  [0, "08:30", 45, "Mme A. LEROY", "examen", 1],
  [0, "09:30", 30, "M. K. BENALI", "ajustage", 0],
  [0, "10:00", 45, "Mme S. PICHON", "examen", 1],
  [0, "11:00", 30, "M. R. FAURE", "livraison", 0],
  [0, "14:00", 60, "Mme N. GARCIA", "lentilles", 1],
  [0, "15:15", 45, "M. T. MOREL", "examen", 1],
  [0, "16:15", 30, "Mme L. VIDAL", "ajustage", 0],
  [0, "17:00", 45, "M. P. CHEVALIER", "examen", 1],
  [0, "18:00", 30, "Mme C. RIVIÈRE", "livraison", 0],
  [1, "09:00", 30, "M. D. OLIVEIRA", "livraison", 0],
  [1, "09:45", 45, "Mme H. BARRÉ", "examen", 1],
  [1, "10:45", 45, "Enfant · L. MARTY", "enfant", 1],
  [1, "12:00", 30, "M. Y. SOARES", "ajustage", 0],
  [1, "14:30", 45, "Mme E. DUPONT", "lentilles", 0],
  [1, "15:30", 30, "M. J. ROUX", "urgence", 0],
  [1, "16:15", 45, "Mme V. LAMBERT", "examen", 1],
  [1, "17:30", 45, "M. A. NGUYEN", "examen", 1],
  [2, "09:00", 45, "Mme F. GUILLOT", "conseil", 0],
  [2, "10:00", 30, "M. B. LEFEBVRE", "montage", 0],
  [2, "10:45", 45, "Mme I. BLANC", "conseil", 1],
  [2, "11:45", 30, "M. S. PEREZ", "ajustage", 0],
  [2, "14:00", 45, "Mme N. TRAORÉ", "livraison", 1],
  [2, "15:00", 30, "M. A. COSTA", "montage", 0],
  [2, "15:45", 45, "Mme M. CARON", "conseil", 0],
  [2, "16:45", 30, "M. L. MARTY", "ajustage", 0],
  [2, "17:30", 45, "Mme A. COSTA", "livraison", 1],
];

const R_AUD = [
  [0, "08:30", 60, "M. G. MERCIER", "bilan", 1],
  [0, "09:45", 45, "Mme O. FONTAINE", "essai", 1],
  [0, "10:45", 30, "M. L. ADAM", "reglage", 0],
  [0, "11:30", 30, "Mme P. RENARD", "reglage", 0],
  [0, "14:00", 60, "M. C. DELAUNAY", "bilan", 1],
  [0, "15:15", 45, "Mme J. BOUCHER", "essai", 0],
  [0, "16:15", 30, "M. E. SIMON", "urgence", 0],
  [0, "17:00", 45, "Mme R. NOËL", "controle", 1],
  [0, "18:00", 45, "M. F. GAUTIER", "livraison", 0],
  [1, "09:00", 45, "Mme T. AMARA", "controle", 1],
  [1, "10:00", 60, "M. V. LEGRAND", "bilan", 1],
  [1, "11:15", 30, "Mme A. POIRIER", "reglage", 0],
  [1, "14:30", 45, "M. S. BERTIN", "essai", 1],
  [1, "15:30", 45, "Mme D. MARCHAL", "livraison", 0],
  [1, "16:30", 30, "M. H. LOPES", "reglage", 0],
  [1, "17:15", 60, "Mme K. AUBERT", "bilan", 1],
];

const ICO = {
  grid: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
  cal: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/>',
  bank: '<path d="M3 21h18M5 21V9M19 21V9M3 9l9-6 9 6M9 21v-6h6v6"/>',
  chat: '<path d="M21 12a8 8 0 1 1-3.2-6.4"/><path d="M21 5v5h-5"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  users: '<circle cx="9" cy="8" r="3.2"/><path d="M3 20a6 6 0 0 1 12 0"/><path d="M16.5 6.2a3 3 0 0 1 0 5.6M18 20a6 6 0 0 0-2-4.5"/>',
  book: '<path d="M4 5a2 2 0 0 1 2-2h5v18H6a2 2 0 0 1-2-2z"/><path d="M20 5a2 2 0 0 0-2-2h-5v18h5a2 2 0 0 0 2-2z"/>',
  folder: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
  ticket: '<path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z"/>',
};

const NAV = [
  ["grid", "Tableau de bord", false],
  ["cal", "Calendrier", false],
  ["mail", "Messagerie MSS", false],
  ["bank", "Établissements", false],
  ["chat", "Consentements", false],
  ["clock", "Rendez-vous", true],
  ["users", "Utilisateurs", true],
  ["book", "Annuaire santé", false],
  ["folder", "Dossier", true],
];

function NavItem({ ic, lab, chev, on }) {
  return (
    <span className={on ? "agx-on" : ""}>
      <svg viewBox="0 0 24 24" aria-hidden="true" dangerouslySetInnerHTML={{ __html: ICO[ic] }} />
      {lab}
      {chev ? <em>&rsaquo;</em> : null}
    </span>
  );
}

const KEYS = [
  {
    t: "Une colonne par praticien",
    d: "Le patient choisit son praticien au moment de réserver. Son rendez-vous tombe dans la bonne colonne, sans que personne ne le déplace.",
  },
  {
    t: "Une couleur par prestation",
    d: "Examen, adaptation, livraison, urgence : la journée se lit d'un coup d'œil, avant même d'ouvrir un dossier.",
  },
  {
    t: "L'établissement toujours visible",
    d: "Plusieurs points de vente, plusieurs activités : le sélecteur en haut à gauche dit lequel vous regardez, et le choix est mémorisé.",
  },
  {
    t: "L'identité déjà qualifiée",
    d: "La pastille INS signale les patients dont l'identité est vérifiée. Le document que vous enverrez ensuite ne se trompera pas de dossier.",
  },
];

function mins(h) {
  const [a, b] = h.split(":");
  return +a * 60 + +b;
}
function fmt(m) {
  return String(Math.floor(m / 60)).padStart(2, "0") + ":" + String(m % 60).padStart(2, "0");
}

function Lines() {
  const out = [];
  for (let t = START; t <= END; t += 30) {
    const top = (t - START) * PX;
    out.push(
      <div key={"l" + t} className={"agx-line" + (t % 60 === 0 ? " agx-h" : "")} style={{ top }} />
    );
    if (t % 60 === 0)
      out.push(
        <div key={"h" + t} className="agx-hlab" style={{ top: top - 7 }}>
          {fmt(t)}
        </div>
      );
  }
  return out;
}

function Screen({ etab, ville, cols, rdv, types }) {
  return (
    <div className="agx-app">
      <aside className="agx-side">
        <img className="agx-logo" src="/logos/ohmyvue-blanc.svg" alt="OhMyVue" />
        <div className="agx-lbl">Établissement</div>
        <div className="agx-selrow">
          <div className="agx-sel">
            <span>{etab}</span>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <div className="agx-ok">OK</div>
        </div>
        <div className="agx-hint">Sélectionnez votre contexte. Le choix est mémorisé.</div>
        <nav>
          {NAV.map(([ic, lab, chev]) => (
            <NavItem key={lab} ic={ic} lab={lab} chev={chev} on={lab === "Calendrier"} />
          ))}
        </nav>
        <div className="agx-rule" />
        <nav>
          <NavItem ic="ticket" lab="Tickets et assistance" chev on={false} />
        </nav>
        <div className="agx-dmp">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Consulter un DMP
        </div>
        <div className="agx-user">
          <b>{cols[0][2]}</b>
          <span>{cols[0][0]}</span>
        </div>
        <div className="agx-sess">
          <i />
          Session ouverte
        </div>
      </aside>

      <div className="agx-main">
        <div className="agx-title">
          <h3>Mes rendez-vous</h3>
          <span className="agx-tag">
            {etab} · {ville}
          </span>
          <span className="agx-date">Jeudi 10 septembre</span>
        </div>

        <div className="agx-legend">
          {Object.keys(types).map((k) => (
            <span key={k} className="agx-lg">
              <i style={{ background: types[k][1], borderLeftColor: types[k][2] }} />
              {types[k][0]}
            </span>
          ))}
          <span className="agx-lgn">INS = identité du patient qualifiée</span>
        </div>

        <div className="agx-scroll">
          <div className="agx-cal">
            <div className="agx-head">
              <div className="agx-gut" />
              {cols.map(([nom, role, ini, col]) => (
                <div className="agx-colh" key={ini}>
                  <span className="agx-av" style={{ background: col }}>
                    {ini}
                  </span>
                  <span className="agx-nm">{nom}</span>
                  <span className="agx-ro">{role}</span>
                </div>
              ))}
            </div>

            <div className="agx-body" style={{ height: (END - START) * PX + 8 }}>
              <div className="agx-gut">
                <Lines />
              </div>
              {cols.map((c, ci) => (
                <div className="agx-col" key={c[2]}>
                  {rdv
                    .filter((r) => r[0] === ci)
                    .map(([, st, dur, who, kind, ins]) => {
                      const [lab, bg, bd, fg] = types[kind];
                      return (
                        <div
                          key={st + who}
                          className={"agx-ev" + (dur <= 30 ? " agx-sm" : "")}
                          style={{
                            top: (mins(st) - START) * PX,
                            height: dur * PX - 3,
                            background: bg,
                            borderLeftColor: bd,
                            color: fg,
                          }}
                        >
                          <span className="agx-t">
                            {st} – {fmt(mins(st) + dur)}
                          </span>
                          <span className="agx-w">
                            {who}
                            {ins ? <i className="agx-ins">INS</i> : null}
                          </span>
                          <span className="agx-k">{lab}</span>
                        </div>
                      );
                    })}
                </div>
              ))}
              <div className="agx-now" style={{ top: (612 - START) * PX }}>
                <i />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AgendaType() {
  return (
    <div className="agx">
      <SEO
        title="À quoi ressemble l'agenda · MetaConnect"
        description="L'agenda d'un opticien et celui d'un audioprothésiste sur une journée : une colonne par praticien, une couleur par prestation, l'établissement visible."
        canonical="/agenda-type"
      />
      <style>{CSS}</style>

      <section className="agx-hero">
        <div className="agx-wrap">
          <span className="agx-pill">Exemple</span>
          <h1>L'agenda, vu de l'intérieur</h1>
          <p className="agx-lede">
            Une journée complète, telle qu'elle s'affiche le matin en ouvrant le magasin. À gauche
            l'agenda d'un opticien, plus bas celui d'un audioprothésiste. Même outil, mêmes
            habitudes, prestations différentes.
          </p>
          <div className="agx-demo">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v5M12 16.5v.01" />
            </svg>
            Établissements, praticiens et patients fictifs
          </div>
        </div>
      </section>

      <section className="agx-sec">
        <div className="agx-wrap">
          <div className="agx-h2">
            <span className="agx-k2">Chez un opticien</span>
            <h2>Deux opticiens, une monteuse-vendeuse, une seule journée</h2>
          </div>
          <Screen
            etab="Optique Rivage"
            ville="45150 Jargeau"
            cols={C_OPT}
            rdv={R_OPT}
            types={T_OPT}
          />
        </div>
      </section>

      <section className="agx-sec agx-alt">
        <div className="agx-wrap">
          <div className="agx-h2">
            <span className="agx-k2">Chez un audioprothésiste</span>
            <h2>Bilans, essais, réglages : les mêmes repères</h2>
          </div>
          <Screen
            etab="Audition Rivage"
            ville="45150 Jargeau"
            cols={C_AUD}
            rdv={R_AUD}
            types={T_AUD}
          />
          <p className="agx-note">
            Un établissement qui exerce les deux activités bascule de l'un à l'autre par le sélecteur
            d'établissement, sans changer d'outil ni de compte.
          </p>
        </div>
      </section>

      <section className="agx-sec">
        <div className="agx-wrap">
          <div className="agx-h2">
            <span className="agx-k2">Vision patient</span>
            <h2>Et de l'autre côté, sur son téléphone</h2>
            <p className="agx-lede">
              Ce que votre patient voit quand il réserve, un dimanche soir ou entre deux rendez-vous.
              Sept écrans, de la prestation au document déposé.
            </p>
          </div>
          <PatientBooking />
          <p className="agx-note">
            Établissement, praticiens et patient inventés : aucune donnée réelle n'apparaît sur
            cette page.
          </p>
        </div>
      </section>

      <section className="agx-sec agx-alt">
        <div className="agx-wrap">
          <div className="agx-h2">
            <span className="agx-k2">À retenir</span>
            <h2>Ce que vous voyez d'un coup d'œil</h2>
          </div>
          <div className="agx-keys">
            {KEYS.map((k) => (
              <div className="agx-key" key={k.t}>
                <h3>{k.t}</h3>
                <p>{k.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="agx-cta">
        <div className="agx-wrap">
          <h2>Vous voulez le voir tourner sur vos horaires ?</h2>
          <p>
            On reprend vos prestations, vos praticiens et vos créneaux, et on vous montre le résultat
            en quinze minutes.
          </p>
          <Link className="agx-btn" to="/demo">
            Prendre rendez-vous
          </Link>
        </div>
      </section>
    </div>
  );
}

const CSS = `
.agx{
  --ground:#F5F5F5;--surface:#fff;--line:#E6E8EC;--text:#0F172A;--muted:#5A6478;
  --blue:#0080FF;--ink:#172344;--ink2:#0D1A30;--slate:#2F3957;--dim:#636B81;
  background:var(--ground);color:var(--text);
  font-family:"Instrument Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
  -webkit-font-smoothing:antialiased;
}
.agx *{box-sizing:border-box}
.agx h1,.agx h2,.agx h3{margin:0;color:var(--text);font-weight:600;text-wrap:balance}
.agx h1{font-size:clamp(29px,3.6vw,40px);line-height:1.14;letter-spacing:-.02em}
.agx h2{font-size:clamp(21px,2.3vw,28px);line-height:1.2;letter-spacing:-.015em}
.agx p{margin:0;color:var(--muted);line-height:1.6}
.agx-wrap{max-width:1180px;margin:0 auto;padding:0 28px}
.agx-pill{display:inline-flex;border-radius:999px;background:#E7ECF3;color:#45526B;
  font-size:11.5px;font-weight:600;letter-spacing:.11em;text-transform:uppercase;padding:7px 15px}
.agx-hero{padding:82px 0 30px;text-align:center}
.agx-hero h1{margin:16px auto 0;max-width:22ch}
.agx .agx-lede{max-width:66ch;margin:16px auto 0;font-size:16.5px}
.agx-demo{display:inline-flex;align-items:center;gap:9px;background:#FEF6E7;border:1px solid #F3DCA8;
  color:#8A6414;border-radius:999px;font-size:12.6px;font-weight:600;padding:8px 16px;margin-top:22px}
.agx-demo svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2;
  stroke-linecap:round;stroke-linejoin:round;flex:0 0 15px}

.agx-sec{padding:46px 0}
.agx-alt{background:var(--surface);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.agx-h2{max-width:64ch;margin:0 auto 26px;text-align:center}
.agx-k2{display:block;font-size:11.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;
  color:var(--blue);margin-bottom:11px}
.agx-note{max-width:70ch;margin:22px auto 0;text-align:center;font-size:14px}

.agx-app{display:flex;background:#fff;border:1px solid #D8DCE2;border-radius:16px;overflow:hidden;
  box-shadow:0 26px 60px -34px rgba(15,23,42,.45)}
.agx-side{width:216px;flex:0 0 216px;background:var(--ink);color:#fff;padding:16px 12px 14px;
  display:flex;flex-direction:column}
.agx-logo{display:block;height:24px;width:auto;margin:2px 4px 16px}
.agx-lbl{font-size:11px;color:#fff;margin:0 4px 5px}
.agx-selrow{display:flex;gap:6px;margin:0 4px}
.agx-sel{flex:1;min-width:0;background:var(--slate);color:#fff;border:1px solid #3C476A;
  border-radius:6px;padding:7px 9px;font-size:12.2px;display:flex;align-items:center;gap:6px}
.agx-sel span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.agx-sel svg{width:12px;height:12px;margin-left:auto;flex:0 0 12px;stroke:#fff;fill:none;
  stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}
.agx-ok{border:1px solid #3C476A;border-radius:6px;padding:7px 11px;font-size:12.2px;
  font-weight:600;color:#fff}
.agx-hint{font-size:10.4px;color:var(--dim);margin:7px 4px 14px;line-height:1.45}
.agx-side nav{display:grid;gap:1px}
.agx-side nav span{display:flex;align-items:center;gap:9px;padding:7px 9px;border-radius:7px;
  font-size:12.6px;color:#fff}
.agx-side nav span svg{width:14px;height:14px;flex:0 0 14px;stroke:#fff;fill:none;stroke-width:1.8;
  stroke-linecap:round;stroke-linejoin:round;opacity:.9}
.agx-side nav span em{margin-left:auto;font-style:normal;color:#8C93A8;font-size:12px}
.agx-side nav .agx-on{background:var(--ink2);font-weight:600}
.agx-rule{height:1px;background:#2A3559;margin:13px 4px;margin-top:auto}
.agx-dmp{background:var(--slate);color:#fff;border-radius:7px;padding:9px 12px;font-size:12.4px;
  font-weight:600;text-align:center;display:flex;align-items:center;justify-content:center;
  gap:8px;margin:0 4px}
.agx-dmp svg{width:15px;height:15px;stroke:#fff;fill:none;stroke-width:1.9}
.agx-user{display:flex;align-items:center;gap:9px;margin:16px 4px 0}
.agx-user b{width:30px;height:30px;flex:0 0 30px;border-radius:9px;background:#F5F5F5;color:#172344;
  font-size:11.5px;font-weight:700;display:grid;place-items:center}
.agx-user span{font-size:12.6px;font-weight:600;color:#fff}
.agx-sess{display:flex;align-items:center;gap:7px;margin:12px 4px 0;font-size:11.4px;
  font-weight:600;color:#fff}
.agx-sess i{width:9px;height:9px;border-radius:999px;background:#00C950;display:block;flex:0 0 9px}

.agx-main{flex:1;min-width:0;display:flex;flex-direction:column}
.agx-title{display:flex;align-items:center;gap:12px;padding:16px 20px 10px;flex-wrap:wrap}
.agx-title h3{font-size:19px}
.agx-tag{font-size:12.2px;font-weight:600;color:#4B3A8C;background:#F0EBFB;border:1px solid #DCD2F5;
  border-radius:999px;padding:5px 12px}
.agx-date{margin-left:auto;font-size:13.2px;font-weight:600;color:#25304A}
.agx-legend{display:flex;flex-wrap:wrap;gap:8px 16px;align-items:center;padding:0 20px 13px}
.agx-lg{display:inline-flex;align-items:center;gap:7px;font-size:12px;color:#4A5468}
.agx-lg i{width:11px;height:11px;border-radius:3px;border-left:3px solid;display:block}
.agx-lgn{margin-left:auto;font-size:11.6px;color:#8A93A5}

.agx-scroll{overflow-x:auto;border-top:1px solid var(--line)}
.agx-cal{min-width:640px}
.agx-head{display:flex;border-bottom:1px solid var(--line);background:#FAFBFC}
.agx-gut{width:60px;flex:0 0 60px;position:relative}
.agx-colh{flex:1;min-width:0;padding:11px 12px;border-left:1px solid var(--line);
  display:flex;flex-direction:column;gap:1px}
.agx-av{width:25px;height:25px;border-radius:50%;color:#fff;font-size:10.5px;font-weight:700;
  display:grid;place-items:center;margin-bottom:5px}
.agx-nm{font-size:12.8px;font-weight:600;color:#1B2438}
.agx-ro{font-size:11.2px;color:#7C8698}
.agx-body{display:flex;position:relative;overflow:hidden}
.agx-col{flex:1;min-width:0;position:relative;border-left:1px solid var(--line)}
.agx-line{position:absolute;left:0;right:0;height:0;border-top:1px solid #EDF0F3}
.agx-line.agx-h{border-top-color:#E1E5EA}
.agx-hlab{position:absolute;right:9px;font-size:11px;color:#9AA3B2;font-variant-numeric:tabular-nums}
.agx-body .agx-gut .agx-line{left:auto;right:0;width:8px}
.agx-ev{position:absolute;left:5px;right:5px;border-radius:7px;border-left:3px solid;padding:5px 8px;
  overflow:hidden;display:flex;flex-direction:column;gap:1px}
.agx-t{font-size:10.4px;font-weight:600;opacity:.85;font-variant-numeric:tabular-nums}
.agx-w{font-size:12px;font-weight:600;line-height:1.25;display:flex;align-items:center;gap:6px}
.agx-k{font-size:10.6px;opacity:.75;line-height:1.2}
.agx-sm{padding:3px 8px}
.agx-sm .agx-t{font-size:9.6px}
.agx-sm .agx-w{font-size:11.4px}
.agx-sm .agx-k{display:none}
.agx-ins{font-style:normal;font-size:8.4px;font-weight:700;letter-spacing:.06em;
  background:rgba(255,255,255,.72);border-radius:3px;padding:1px 4px}
.agx-now{position:absolute;left:60px;right:0;height:0;border-top:2px solid #E5484D;z-index:5}
.agx-now i{position:absolute;left:-5px;top:-5px;width:9px;height:9px;border-radius:50%;
  background:#E5484D;display:block}

.agx-keys{display:grid;grid-template-columns:repeat(2,1fr);gap:16px;max-width:900px;margin:0 auto}
.agx-key{background:var(--surface);border:1px solid var(--line);border-radius:16px;padding:24px 22px}
.agx-key h3{font-size:16.5px;margin-bottom:8px}
.agx-key p{font-size:14px}

.agx-cta{background:var(--blue);padding:56px 0;text-align:center}
.agx-cta h2{color:#fff;margin-bottom:12px}
.agx-cta p{color:rgba(255,255,255,.9);font-size:15.5px;max-width:62ch;margin:0 auto 24px}
.agx-btn{display:inline-flex;align-items:center;border-radius:999px;background:#fff;color:var(--blue);
  font-weight:600;font-size:15px;text-decoration:none;padding:13px 28px}
.agx-btn:hover{background:#EAF4FF;color:var(--blue)}

@media (max-width:900px){
  .agx-keys{grid-template-columns:1fr}
  .agx-side{display:none}
  .agx-hero{padding:56px 0 24px}
}
.agx a:focus-visible{outline:2px solid var(--blue);outline-offset:3px;border-radius:6px}
`;
